module.exports = __webpack_public_path__ + "img/vaughan.dde43cde.jpg";